import { render, staticRenderFns } from "./GridContainer.vue?vue&type=template&id=8a47ae8e&scoped=true"
import script from "./GridContainer.vue?vue&type=script&lang=ts"
export * from "./GridContainer.vue?vue&type=script&lang=ts"
import style0 from "./GridContainer.vue?vue&type=style&index=0&id=8a47ae8e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a47ae8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a47ae8e')) {
      api.createRecord('8a47ae8e', component.options)
    } else {
      api.reload('8a47ae8e', component.options)
    }
    module.hot.accept("./GridContainer.vue?vue&type=template&id=8a47ae8e&scoped=true", function () {
      api.rerender('8a47ae8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/GridContainer.vue"
export default component.exports